import * as React from "react";
import { DatasheetFormatManagementMode } from "@modules/datasheets/components/datasheet-format-management/datasheet-format-management.types";

export const useDatasheetFormatManagementController = () => {
  const [datasheetFormatManagementMode, setDatasheetFormatManagementMode] = React.useState<
    DatasheetFormatManagementMode | undefined
  >();

  const closeDatasheetFormatManagement = React.useCallback(() => {
    setDatasheetFormatManagementMode(undefined);
  }, []);

  const handleDatasheetFormatManagementSubmit = React.useCallback(() => {    
    closeDatasheetFormatManagement();
  }, [closeDatasheetFormatManagement]);

  return {
    datasheetFormatManagementMode,
    setDatasheetFormatManagementMode,
    closeDatasheetFormatManagement,
    handleDatasheetFormatManagementSubmit,
  };
};